export { default as facebook } from './facebook';
export { default as youtube } from './youtube';
export { default as phone } from './phone';
export { default as insta } from './insta';
export { default as lions } from './lions';



// WEBPACK FOOTER //
// ./src/components/modules/Icons/index.js